module.exports = __webpack_public_path__ + "static/media/004.37caf3d2.jpg";